import React from "react";

export default function ChildEmptyState({ title, description }) {
  return (
    <div className="rounded-[24px] border border-dashed border-slate-300/80 bg-slate-50/80 px-4 py-5 text-sm text-slate-600 shadow-inner dark:border-slate-600/70 dark:bg-slate-900/40 dark:text-slate-300">
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-2xl bg-white text-lg font-bold text-slate-400 shadow-sm dark:bg-white/10 dark:text-slate-300">
        -
      </div>
      <p className="font-semibold text-slate-700 dark:text-slate-100">{title}</p>
      {description && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{description}</p>}
    </div>
  );
}
